import { Anchor, Box, Flex, Group, Stack, Text } from '@mantine/core'
import { KnockNMLSIDIcon } from '@phoenix-web/icons-images'
import {
  COPYRIGHT,
  DO_NOT_SELL_INFO_PATH,
  FOOTER_LINKS,
  KNOCK_LENDING_NMLS,
  PRIVACY_POLICY_PATH,
  TERMS_OF_USE_PATH,
} from '../../constants'
import styles from './SimpleFooter.module.css'

const TERMS_OF_USE_DETAILS = FOOTER_LINKS.find((link) => link.link === TERMS_OF_USE_PATH)
const PRIVACY_POLICY_DETAILS = FOOTER_LINKS.find((link) => link.link === PRIVACY_POLICY_PATH)
const DO_NOT_SELL_INFO_DETAILS = FOOTER_LINKS.find((link) => link.link === DO_NOT_SELL_INFO_PATH)

export default function SimpleFooter({ frontyardUrl }: { frontyardUrl: string }) {
  return (
    <Box className={styles.footerContainer}>
      <Stack gap="xs" align="center">
        <Flex gap={{ base: 'sm', md: 'lg' }} direction={{ base: 'column', md: 'row' }} align="center" justify="center">
          <Group gap="lg">
            <Anchor
              className={styles.footerAnchor}
              href={frontyardUrl + TERMS_OF_USE_DETAILS?.link}
              target={TERMS_OF_USE_DETAILS?.target}
            >
              {TERMS_OF_USE_DETAILS?.label}
            </Anchor>
            <Anchor
              className={styles.footerAnchor}
              href={frontyardUrl + PRIVACY_POLICY_DETAILS?.link}
              target={PRIVACY_POLICY_DETAILS?.target}
            >
              {PRIVACY_POLICY_DETAILS?.label}
            </Anchor>
          </Group>
          <Anchor
            className={styles.footerAnchor}
            href={frontyardUrl + DO_NOT_SELL_INFO_DETAILS?.link}
            target={DO_NOT_SELL_INFO_DETAILS?.target}
          >
            {DO_NOT_SELL_INFO_DETAILS?.label}
          </Anchor>
        </Flex>
        <Flex
          gap={{ base: 'sm', md: 'lg' }}
          direction={{ base: 'column', md: 'row' }}
          pt={{ base: 'sm', md: 'xs' }}
          mb="md"
          align="center"
          justify="center"
        >
          <Group gap="xs" align="center" justify="center">
            <Box pr="xs" display="inline-block" component="span" style={{ verticalAlign: 'middle' }}>
              <KnockNMLSIDIcon />
            </Box>
            {KNOCK_LENDING_NMLS}
          </Group>
          <Text ta="center">{COPYRIGHT}</Text>
        </Flex>
      </Stack>
    </Box>
  )
}
